import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-task-reminder-modal',
  templateUrl: './task-reminder-modal.component.html',
  styleUrls: ['./task-reminder-modal.component.scss'],
})
export class TaskReminderModalComponent  implements OnInit {

  tasks: any[] = [];

  constructor(
    private _modalController: ModalController
  ) { }

  ngOnInit() {
    console.log(this.tasks);
    
  }

  closeModal(){
    this._modalController.dismiss();
  }

}
